import { useQuery } from "@tanstack/react-query";
import { getStoreId } from "../../utils/auth";
import api from "../../api/apiClient";
import { StoreActionType } from "../../types/modules/storeAction.type";

export const useSingleStoreAction = (
  numericStoreId: number | undefined,
  enabled: boolean = true
) => {
  const storeId = numericStoreId ? numericStoreId : getStoreId();
  return useQuery({
    queryKey: ["store-detail-action", storeId],
    queryFn: () =>
      api.get<StoreActionType>(
        `store/action/current?storeId=${storeId}`
      ).then(res => res.data),
    enabled: enabled && !!storeId,
  });
};

export const useInCompleteStore = (
  ownerId?: number
) => {
  const endPoint = ownerId
    ? `store/incomplete?ownerId=${ownerId}`
    : `store/incomplete`;
  return useQuery({
    queryKey: ["store-incomplete", ownerId],
    queryFn: () =>
      api.get<{
        hasIncompleteStore: boolean;
        store?: {
          id: number;
          languages: { languageCode: string; brand: string }[];
          sector: {
            id: number;
            languages: { languageCode: string; name: string }[];
          };
        };
      }>(endPoint).then(res => res.data),
  });
};
